// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
 * Where vars like --palette-fonts-sansSerifStack are used here, they come from
 * ckEditorStlyes.ts and are named in a convention symmetric with the structure
 * of the \`theme\` object.
 */

.ck.ck-cta-form {
	border-radius: 6px;
	border: 0.5px solid #E1E1E1;
	background: var(--palette-panelBackground-default);
	box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.10);
	padding: 12px;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.ck.ck-reset_all .ck.ck-cta-form .ck-cta-form-label {
	text-transform: uppercase;
	font-size: 11px;
	font-weight: 700;
	color: var(--palette-grey-600);
	margin-bottom: 4px;
	font-family: var(--palette-fonts-sansSerifStack);
}

.ck.ck-reset_all .ck.ck-cta-form .ck-cta-form-input {
	background: var(--palette-grey-600);
	border-radius: 4px;
	opacity: 0.8;
	background: var(--palette-grey-200);
  min-width: 225px;
	padding: 8px;
	font-size: 13px;
	font-weight: 500;
	color: var(--palette-grey-1000);
	font-family: var(--palette-fonts-sansSerifStack);
}

.ck.ck-reset_all .ck.ck-cta-form .ck-cta-error {
	outline: 1px solid var(--palette-error-main);
}

.ck.ck-reset_all .ck.ck-cta-form .ck-cta-form-input:hover,
.ck.ck-reset_all .ck.ck-cta-form .ck-cta-form-input:focus {
	background: var(--palette-grey-300);
}

.ck.ck.ck.ck.ck.ck-cta-balloon {
	box-shadow: none;
  background: none;
  border: none;
}

.ck-cta-balloon:before {
	display: none;
}

.ck-cta-balloon:after {
	display: none;
}
`, "",{"version":3,"sources":["webpack://./src/ckeditor5-cta-button/ctaform.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;CACC,kBAAkB;CAClB,2BAA2B;CAC3B,kDAAkD;CAClD,+CAA+C;CAC/C,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,8BAA8B;CAC9B,kBAAkB;CAClB,gDAAgD;AACjD;;AAEA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,YAAY;CACZ,mCAAmC;EAClC,gBAAgB;CACjB,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,+BAA+B;CAC/B,gDAAgD;AACjD;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;;CAEC,mCAAmC;AACpC;;AAEA;CACC,gBAAgB;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd","sourcesContent":["/* \n * Where vars like --palette-fonts-sansSerifStack are used here, they come from\n * ckEditorStlyes.ts and are named in a convention symmetric with the structure\n * of the `theme` object.\n */\n\n.ck.ck-cta-form {\n\tborder-radius: 6px;\n\tborder: 0.5px solid #E1E1E1;\n\tbackground: var(--palette-panelBackground-default);\n\tbox-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.10);\n\tpadding: 12px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 12px;\n}\n\n.ck.ck-reset_all .ck.ck-cta-form .ck-cta-form-label {\n\ttext-transform: uppercase;\n\tfont-size: 11px;\n\tfont-weight: 700;\n\tcolor: var(--palette-grey-600);\n\tmargin-bottom: 4px;\n\tfont-family: var(--palette-fonts-sansSerifStack);\n}\n\n.ck.ck-reset_all .ck.ck-cta-form .ck-cta-form-input {\n\tbackground: var(--palette-grey-600);\n\tborder-radius: 4px;\n\topacity: 0.8;\n\tbackground: var(--palette-grey-200);\n  min-width: 225px;\n\tpadding: 8px;\n\tfont-size: 13px;\n\tfont-weight: 500;\n\tcolor: var(--palette-grey-1000);\n\tfont-family: var(--palette-fonts-sansSerifStack);\n}\n\n.ck.ck-reset_all .ck.ck-cta-form .ck-cta-error {\n\toutline: 1px solid var(--palette-error-main);\n}\n\n.ck.ck-reset_all .ck.ck-cta-form .ck-cta-form-input:hover,\n.ck.ck-reset_all .ck.ck-cta-form .ck-cta-form-input:focus {\n\tbackground: var(--palette-grey-300);\n}\n\n.ck.ck.ck.ck.ck.ck-cta-balloon {\n\tbox-shadow: none;\n  background: none;\n  border: none;\n}\n\n.ck-cta-balloon:before {\n\tdisplay: none;\n}\n\n.ck-cta-balloon:after {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
